import {
  buildProbateLawFirmSelectionPayload,
  getAttorneySearchErrorMessage,
  getAttorneySearchFieldHelperText,
  mergeAttorneyIntoGuardians,
  runAttorneyAutocompleteInputChange,
} from "./attorneySearch";

export function createProbateAttorneySearchErrorHandler(toast) {
  return (error) => {
    toast.error(getAttorneySearchErrorMessage(error));
  };
}

export function handleProbateAttorneySelection(updateData, data, index, attorney) {
  updateData({
    ...data,
    guardians: mergeAttorneyIntoGuardians(data.guardians, index, attorney),
  });
}

export function handleProbateLawFirmChange(
  updateData,
  data,
  newValue,
  lawFirmAddress,
  attorneyOfRecord,
  attorneyInvolved,
  onClear
) {
  if (newValue) {
    updateData(
      buildProbateLawFirmSelectionPayload(
        data,
        newValue.value,
        lawFirmAddress,
        attorneyOfRecord,
        attorneyInvolved
      )
    );
    return;
  }

  if (onClear) {
    onClear();
  }
}

export function runProbateLawFirmAttorneySync(
  lawFirm,
  fetchLocationsByLawFirm,
  fetchAttorneysByLawFirm
) {
  if (!lawFirm) {
    return;
  }

  fetchLocationsByLawFirm(lawFirm);
  fetchAttorneysByLawFirm(lawFirm);
}

export function createProbateAttorneyInputChangeHandler(debouncedSearch) {
  return (_event, value, reason) => {
    runAttorneyAutocompleteInputChange(reason, value, debouncedSearch);
  };
}

export function buildProbateAttorneySearchInputHandler(setAttorneySearchInput, debouncedSearch) {
  const searchHandler = createProbateAttorneyInputChangeHandler(debouncedSearch);
  return (event, value, reason) => {
    setAttorneySearchInput(value);
    searchHandler(event, value, reason);
  };
}

export function buildProbateGuardianAttorneySearchHelperText(
  attorneySearchInput,
  loadingAttorneys,
  attorneyCount,
  fieldError
) {
  return (
    fieldError ||
    getAttorneySearchFieldHelperText(attorneySearchInput, loadingAttorneys, attorneyCount)
  );
}

export function handleProbateGuardianManualAttorneyEntry({
  updateData,
  data,
  index,
  guardians,
  clearAttorneys,
  setAttorneySearchInput,
}) {
  const updatedGuardians = [...guardians];
  updatedGuardians[index] = {
    ...updatedGuardians[index],
    showAttorneyForm: true,
    attorney: null,
  };
  clearAttorneys();
  setAttorneySearchInput("");
  updateData({ ...data, guardians: updatedGuardians });
}
